<template>
    <section class="app-main">
        <el-tabs type="border-card" style="margin-top:30px;">
            <el-tab-pane label="主题管理">
                <banner section="6" :reload="reload" :size="size" />
            </el-tab-pane>
            <el-tab-pane label="新品库">
                <goods section="6" @mapId="mapIdd($event)"   :classify="classify" />
            </el-tab-pane>
            <el-tab-pane label="首页推荐">
                <RemList section="6" :mapId="mapId"  :classify="classify" />
            </el-tab-pane>
            <el-tab-pane label="热门预售">
                <hot-goods section="6" :mapId="mapId"  :classify="classify" />
            </el-tab-pane>
            <el-tab-pane label="限量好货">
                <good-stuff section="6" :mapId="mapId"  :classify="classify" />
            </el-tab-pane>
        </el-tabs>
    </section>
</template>



<script>
import Banner   from './../components/banner'
import Goods    from './goods'
import RemList    from './rem'
import HotGoods   from './hot-goods'
import GoodStuff   from './good-stuff'


export default {
    components: { Banner, Goods, RemList, HotGoods, GoodStuff },
    data() {
        return {
            classify:[],
            mapId:"",
            size: '375*260'
        }
    },
    methods: {
        mapIdd(val) {
            this.mapId = String(val);
            console.log(this.mapId);
        },  
    },
    created(){
        // this.getData()
    }
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        font-size: 16px;
    }
}
</style>
